<template>
  <div>
    <Table
      :columns="columns"
      :data="resources"
      size="small"
      highlight-row
      stripe
      max-height="700"
    >
      <template slot-scope="{ row }" slot="barcode">
        {{ row.product ? row.product.barcode : 'N/A' }}
      </template>
      <template slot-scope="{ row }" slot="product_name">
        {{ row.product ? row.product.product_name_en : 'N/A' }}
      </template>
      <template slot-scope="{ row }" slot="unit_of_measure">
        {{ row.unit_of_measure ? row.unit_of_measure.uom_name_en : 'N/A' }}
      </template>
      <template slot-scope="{ row }" slot="cost">
        <ts-display-currency
          :amount="row.input_cost"
          :currency_id="row.input_currency_id"
        />
      </template>
      <template slot-scope="{ row }" slot="amount">
        <ts-display-currency
          :amount="row.input_grand_total"
          :currency_id="row.input_currency_id"
        />
      </template>
      <template slot-scope="{ row }" slot="converted_amount">
        <ts-display-currency
          :amount="row.grand_total"
          :currency_id="row.currency_id"
        />
      </template>
      <template slot-scope="{ row }" slot="action">
        <a href="#" @click.prevent="viewSerialProduct(row)">
          <i class="fas fa-list"></i>
        </a>
      </template>
    </Table>
  </div>
</template>
<script>
import DisplaySerialsProduct from './components/display-serial-product.vue'

export default {
  name: 'tableExpand',
  props: {
    row: Object
  },
  data() {
    return {
      show_modal_add_product: false
    }
  },
  computed: {
    resources() {
      return this.row.trade_in_details
    },
    columns() {
      return [
        {
          title: this.$t('stockIn.barcode'),
          slot: 'barcode',
          with: 90,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('stockIn.productName'),
          slot: 'product_name',
          minWidth: 150,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('stockIn.uom'),
          slot: 'unit_of_measure',
          with: 90,
          align: 'center',
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('stockIn.cost'),
          slot: 'cost',
          with: 90,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('stockIn.qty'),
          key: 'quantity',
          with: 90,
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('stockIn.amount'),
          slot: 'amount',
          with: 120,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('stockIn.convertedAmount'),
          slot: 'converted_amount',
          minWidth: 150,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          minWidth: 90
        }
      ]
    }
  },
  methods: {
    viewSerialProduct(item) {
      this.$modal.show(
        DisplaySerialsProduct,
        {
          data: item
        },
        {
          height: 'auto',
          width: '550px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: true
        }
      )
    }
  }
}
</script>
